import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

import { useCreateAgentEligibility } from './useCreateAgentEligibility.ts';

type UseCreateAgentEntryPointArgs = {
	source: string;
	isMenuOpen?: boolean;
};

type UseCreateAgentEntryPointResult = {
	shouldRenderInlineCreateAgentItem: boolean;
	shouldRenderStudioRedirectCreateAgentItem: boolean;
};

export const useCreateAgentEntryPoint = ({
	source,
	isMenuOpen = true,
}: UseCreateAgentEntryPointArgs): UseCreateAgentEntryPointResult => {
	const isAgentCreationEligible = useCreateAgentEligibility({
		source,
		skip: !isMenuOpen || !fg('cc_fd_agent_creation_connie_create_gate'),
	});

	const shouldRenderInlineCreateAgentItem =
		isAgentCreationEligible && expValEquals('cc_inline_agent_create', 'isEnabled', true);

	const shouldRenderStudioRedirectCreateAgentItem =
		isAgentCreationEligible &&
		expValEquals('cc_fd_agent_creation_connie_create', 'isEnabled', true);

	return {
		shouldRenderInlineCreateAgentItem,
		shouldRenderStudioRedirectCreateAgentItem,
	};
};
